import script from "./WageChartVertical.vue?vue&type=script&setup=true&lang=js"
export * from "./WageChartVertical.vue?vue&type=script&setup=true&lang=js"

import "./WageChartVertical.vue?vue&type=style&index=0&id=26c482bc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c482bc"]])

export default __exports__